import { Controller } from "@hotwired/stimulus"

// Accessible FAQ accordion — one panel open at a time.
// data-controller="accordion"
//   trigger: <button data-accordion-target="trigger"
//                    data-action="accordion#toggle"
//                    aria-expanded="false" aria-controls="<panel id>">
//   panel:   <div data-accordion-target="panel" hidden>
//
// Triggers and panels must appear in matching order. The <button> element
// handles Enter/Space and focus natively, so no extra keyboard wiring is
// needed — we only manage aria-expanded and the panel's hidden state.
export default class extends Controller {
  static targets = ["trigger", "panel"]

  toggle(event) {
    const index = this.triggerTargets.indexOf(event.currentTarget)
    const willOpen = event.currentTarget.getAttribute("aria-expanded") !== "true"

    this.triggerTargets.forEach((_, i) => this.setOpen(i, willOpen && i === index))
  }

  setOpen(index, open) {
    this.triggerTargets[index].setAttribute("aria-expanded", open ? "true" : "false")
    this.panelTargets[index].hidden = !open
  }
}
